var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0.144664812 L11,3.31759849 L9.00107159,3.31759849 C8.27126182,3.31759849 7.77897611,3.46178468 7.52421446,3.75015705 C7.2694528,4.03852942 7.14219872,4.47120763 7.14245221,5.04819169 L7.14245221,7.31975231 L10.8726192,7.31975231 L10.3760241,10.8775016 L7.14245221,10.8775016 L7.14245221,20 L3.24650005,20 L3.24650005,10.8775016 L0,10.8775016 L0,7.31975231 L3.24650005,7.31975231 L3.24650005,4.69963206 C3.24650005,3.20918963 3.68783343,2.05330701 4.57050019,1.23198421 C5.45316695,0.410661402 6.62874624,-1.06250451e-16 8.09723807,0 C9.34493645,0 10.3125238,0.0481019474 11,0.144305842 L11,0.144664812 Z",
    id: "Shape"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.svg";
export { ForwardRef as ReactComponent };